module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "h-100"
  }, [_c('v-list', {
    staticClass: "pa-1"
  }, [_c('v-list-tile', {
    attrs: {
      "avatar": ""
    }
  }, [_c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLogin),
      expression: "!isLogin"
    }],
    staticClass: "align-center pointer",
    attrs: {
      "mt-4": ""
    },
    on: {
      "click": _vm.showLoginModal
    }
  }, [_c('v-list-tile-avatar', [_c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "slot": "activator",
      "icon": "",
      "large": ""
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("fas fa-user-circle")])], 1)], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_c('a', {
    staticClass: "font-lg"
  }, [_vm._v(_vm._s(_vm.$t('header.login')))])])], 1)], 1), _vm._v(" "), _c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLogin),
      expression: "isLogin"
    }],
    staticClass: "align-center pointer",
    attrs: {
      "mt-4": ""
    },
    on: {
      "click": _vm.goUserData
    }
  }, [_c('v-list-tile-avatar', {
    attrs: {
      "color": "primary"
    }
  }, [(_vm.user != null && _vm.user.image != null) ? _c('img', {
    attrs: {
      "src": _vm.user.image
    }
  }) : _c('span', {
    staticClass: "headline white--text"
  }, [_vm._v("\n\t\t\t                " + _vm._s(_vm.user != null ? _vm.user.userName.trim().substring(0, 1).toLocaleUpperCase() : '') + "\n\t\t\t            ")])]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    staticClass: "primary--text"
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.user != null ? _vm.user.nickName : '') + "\n\t\t\t\t\t\t\t"), _c('span', {
    staticClass: "ml-2"
  }), _vm._v("\n\t\t\t\t\t\t\t(@" + _vm._s(_vm.user != null ? _vm.user.userName : '') + ")\n\t\t\t\t\t\t")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLogin),
      expression: "isLogin"
    }],
    staticClass: "pt-0 Slogan"
  }, [_c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.routerPage('wallet')
      }
    }
  }, [_c('v-list-tile-action', {
    staticClass: "ml-2"
  }, [_c('v-icon', [_vm._v("fas fa-wallet")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('span', {
    staticClass: "font-22 primary--text fw-700"
  }, [_vm._v(_vm._s(_vm._f("NumFormat")(((_vm.user != null ? _vm.user.iobPower : 0).toFixed(2)))))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('span', [_vm._v("IOB Power")])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', {
    staticClass: "ml-2"
  }), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm._f("NumFormat")(((_vm.user != null ? _vm.user.iobTokens : 0).toFixed(2)))))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('span', [_vm._v("IOB Tokens")])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', {
    staticClass: "ml-2"
  }), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm._f("NumFormat")(((_vm.user != null ? _vm.user.iobPower + _vm.user.iobTokens : 0).toFixed(2)))))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('span', [_vm._v("USD")])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.routerPage('profile')
      }
    }
  }, [_c('v-list-tile-action', {
    staticClass: "ml-2"
  }, [_c('v-icon', [_vm._v("account_box")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$t('menu.profile')))])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.routerPage('signOut')
      }
    }
  }, [_c('v-list-tile-action', {
    staticClass: "ml-2"
  }, [_c('v-icon', [_vm._v("fas fa-sign-out-alt")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$t('menu.signOut')))])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.routerPage('myFeed')
      }
    }
  }, [_c('v-list-tile-action', {
    staticClass: "ml-2"
  }, [_c('v-icon', [_vm._v("fas fa-rss-square")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$t('right.myFeed')))])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.routerPage('profile')
      }
    }
  }, [_c('v-list-tile-action', {
    staticClass: "ml-2"
  }, [_c('v-icon', [_vm._v("fas fa-comment-alt")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$t('menu.posts')))])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.routerPage('profile')
      }
    }
  }, [_c('v-list-tile-action', {
    staticClass: "ml-2"
  }, [_c('v-icon', [_vm._v("fas fa-comments")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$t('menu.comments')))])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.routerPage('profile')
      }
    }
  }, [_c('v-list-tile-action', {
    staticClass: "ml-2"
  }, [_c('v-icon', [_vm._v("fa fa-reply")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$t('menu.replies')))])], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    staticClass: "pt-0 Slogan"
  }, [_c('v-list-tile', {
    staticClass: "d-none",
    on: {
      "click": function($event) {
        return _vm.routerPage('searchUser')
      }
    }
  }, [_c('v-list-tile-action', {
    staticClass: "ml-2"
  }, [_c('v-icon', [_vm._v("fa fa-user-plus")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$t('menu.searchUser')))])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.routerPage('userRanking')
      }
    }
  }, [_c('v-list-tile-action', {
    staticClass: "ml-2"
  }, [_c('v-icon', [_vm._v("fas fa-bolt")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$t('menu.IOBPowerRanking')))])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    staticClass: "pt-0"
  }, [_c('v-list-group', [_c('v-list-tile', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('v-list-tile-action', {
    staticClass: "ml-2"
  }, [_c('v-icon', [_vm._v("translate")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$t('menu.language') + _vm.$t('menu.locale')))])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    staticClass: "ml-5"
  }, [_c('v-radio-group', {
    staticClass: "ml-2",
    model: {
      value: (_vm.languageModel),
      callback: function($$v) {
        _vm.languageModel = $$v
      },
      expression: "languageModel"
    }
  }, [_c('v-radio', {
    attrs: {
      "color": "primary",
      "label": "English",
      "value": "en-US"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    staticClass: "ml-5"
  }, [_c('v-radio-group', {
    staticClass: "ml-2",
    model: {
      value: (_vm.languageModel),
      callback: function($$v) {
        _vm.languageModel = $$v
      },
      expression: "languageModel"
    }
  }, [_c('v-radio', {
    attrs: {
      "color": "primary",
      "label": "Deutsch",
      "value": "de-DE"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    staticClass: "ml-5"
  }, [_c('v-radio-group', {
    staticClass: "ml-2",
    model: {
      value: (_vm.languageModel),
      callback: function($$v) {
        _vm.languageModel = $$v
      },
      expression: "languageModel"
    }
  }, [_c('v-radio', {
    attrs: {
      "color": "primary",
      "label": "Pусский",
      "value": "ru-RU"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    staticClass: "ml-5"
  }, [_c('v-radio-group', {
    staticClass: "ml-2",
    model: {
      value: (_vm.languageModel),
      callback: function($$v) {
        _vm.languageModel = $$v
      },
      expression: "languageModel"
    }
  }, [_c('v-radio', {
    attrs: {
      "color": "primary",
      "label": "中文（简体）",
      "value": "zh-CN"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    staticClass: "pt-0 pointer"
  }, [_c('v-list-tile-action', {
    staticClass: "ml-2"
  }, [_c('v-icon', [_vm._v("brightness_4")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$t('menu.darkTheme')))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-switch', {
    attrs: {
      "color": "primary"
    },
    model: {
      value: (_vm.darkModeModel),
      callback: function($$v) {
        _vm.darkModeModel = $$v
      },
      expression: "darkModeModel"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list', {
    staticClass: "pt-0 mb-5"
  }, [_c('v-list-group', [_c('v-list-tile', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('v-list-tile-action', {
    staticClass: "ml-2"
  }, [_c('v-icon', [_vm._v("fas fa-palette")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$t('menu.style')))])], 1)], 1), _vm._v(" "), _c('v-list-tile', _vm._l((_vm.themes), function(theme) {
    return _c('v-avatar', {
      key: theme.id,
      staticClass: "pointer mr-2",
      attrs: {
        "size": "24",
        "color": theme.bgColor
      },
      on: {
        "click": function($event) {
          return _vm.changeTheme(theme)
        }
      }
    })
  }), 1)], 1), _vm._v(" "), _c('v-list-tile', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLogin),
      expression: "isLogin"
    }],
    on: {
      "click": function($event) {
        return _vm.routerPage('userSetting')
      }
    }
  }, [_c('v-list-tile-action', {
    staticClass: "ml-2"
  }, [_c('v-icon', [_vm._v("fa fa-cog")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$t('header.settings')))])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.routerPage('userRequest')
      }
    }
  }, [_c('v-list-tile-action', {
    staticClass: "ml-2"
  }, [_c('v-icon', [_vm._v("message")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$t('menu.sendFeedback')))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58af3d1e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Menu.vue
// module id = 440
// module chunks = 0